var React = require('react');

function IconWaitingSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M513.3 62.4c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zM371.5 605.2l-31.1 32.3c-4.9 4.9-13.2 4-17-1.8-57.1-86.9-48.2-205.6 28.3-282.1 76.8-76.8 198-88.9 285.3-31.1 5.2 3.5 6 10.9 1.5 15.4l-32.4 32.4c-3.2 3.2-8.1 3.8-12 1.6-61.3-35.1-143.4-24-195.7 28.3-52.3 52.4-60.8 131.9-25.4 193.1 2.2 3.9 1.6 8.7-1.5 11.9zm297.1 65.3C591.9 747.2 476 754 389.1 696c-5.2-3.4-5.8-10.9-1.4-15.3l31.8-31.8c3.2-3.3 8.3-3.9 12.2-1.5 61.3 37.3 139.7 32 192.8-21.1 53-53.1 63.6-136.7 26.7-198.4-2.4-3.9-1.7-9 1.5-12.2l31.7-31.8c4.5-4.5 11.9-3.8 15.4 1.5 57.6 87.3 45.5 208.4-31.2 285.1z"}));
}

IconWaitingSolid.displayName = "IconWaitingSolid";

IconWaitingSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconWaitingSolid;

IconWaitingSolid.default = IconWaitingSolid;
